import { useLocation } from 'react-router-dom';
import { stripClientPrefix } from '../utils/modulesNavigation';

type RoutePage = 'grid' | 'details' | string;

export function deriveRouteContext(pathname: string) {
  const clientless = stripClientPrefix(pathname);
  const parts = clientless.split('/').filter(Boolean);
  const [first, second, third, fourth] = parts;

  let entity: string | null = null;
  let page: RoutePage | null = first ?? null;

  if (first === 'entities' && second) {
    entity = second;
    if (fourth && third) {
      page = `${third}-${fourth}`;
    } else if (third) {
      page = 'details';
    } else {
      page = 'grid';
    }
  } else {
    entity = second ?? null;
    page = first ?? null;
  }

  return {
    entity,
    page,
  };
}

export function useRouteContext() {
  const location = useLocation();
  return deriveRouteContext(location.pathname);
}
